/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */

export type TaskType = (typeof TaskType)[keyof typeof TaskType];

export const TaskType = {
  analyze_canopy_cover: "analyze_canopy_cover",
  analyze_emergence: "analyze_emergence",
  ortho_creation: "ortho_creation",
  raw_image_upload: "raw_image_upload",
  snip_ortho: "snip_ortho",
  upload_sites_csv: "upload_sites_csv",
  upload_trials_csv: "upload_trials_csv",
  upload_plots_csv: "upload_plots_csv",
} as const;
